Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var cn = require('classnames');
var coreComponentsShared = require('../../../shared');
var Context = require('../../Context.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var cn__default = /*#__PURE__*/_interopDefaultCompat(cn);

var styles = {"component":"system-message__component_1nf3i"};
require('./index.css');

var DEFAULT_PADDING = { bottom: 12 };
var Caption = function (_a) {
    var className = _a.className, children = _a.children, _b = _a.padding, padding = _b === void 0 ? DEFAULT_PADDING : _b;
    var dataTestId = React.useContext(Context.SystemMessageContext).dataTestId;
    return (React__default.default.createElement("span", { className: cn__default.default(styles.component, className), "data-test-id": coreComponentsShared.getDataTestId(dataTestId, 'caption'), style: coreComponentsShared.createPaddingStyle(padding) }, children));
};

exports.Caption = Caption;
